module.exports = __webpack_public_path__ + "static/media/delete.10009e27.svg";